module.exports = __webpack_public_path__ + "img/T2D_rc_19.3c4bb9d2.png";